// extracted by mini-css-extract-plugin
export default {"imageList":"ImageList_imageList__PuTRY","image":"ImageList_image__lg8b+"};